import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { ClipboardPaste } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';

interface ConfirmPasteGridMassActionModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmPasteGridMassActionModal = ({
  isOpen,
  isLoading,
  onConfirm,
  onClose,
}: ConfirmPasteGridMassActionModalProps) => {
  const { translate } = useTranslation();
  const primaryActionLangEnum = isLoading
    ? LangEnum.GLOBAL_IS_PASTING_LOADING_MESSAGE
    : LangEnum.ORDER_PRODUCTS_GRID_PASTE_TO_ALL_MASS_ACTION_LABEL;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="compact"
      header={{
        icon: ClipboardPaste,
        title: translate(LangEnum.ORDER_PRODUCTS_GRID_PASTE_TO_ALL_MASS_ACTION_LABEL),
      }}
      footer={{
        primaryAction: {
          isLoading,
          isDisabled: isLoading,
          onClick: onConfirm,
          label: translate(primaryActionLangEnum),
        },
        secondaryAction: {
          onClick: onClose,
          isDisabled: isLoading,
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
        },
      }}
    >
      <Typography variant="body1">
        {translate(LangEnum.PASTE_GRID_MASS_ACTION_MODAL_CONFIRM_TITLE)}
      </Typography>
    </Modal>
  );
};

export default ConfirmPasteGridMassActionModal;
